import { useEffect } from "react";

import { call, isNativeHost } from "@/bridge/bridge";
const titles: { title: string }[] = [];
function applyTop(): void {
  const top = titles.at(-1);
  if (top === undefined || !isNativeHost()) {
    return;
  }
  void call("nav.setTitle", { title: top.title }).catch(() => {
  });
}

export function useNativeTitle(title: string, enabled: boolean): void {
  useEffect(() => {
    if (!enabled || title.length === 0) {
      return;
    }

    const entry = { title };
    titles.push(entry);
    applyTop();

    return () => {
      const index = titles.lastIndexOf(entry);
      if (index !== -1) {
        titles.splice(index, 1);
      }
      applyTop();
    };
  }, [enabled, title]);
}

/**
 * Screens asking for the native header to be taken away, innermost last —
 * a stack for the same reason titles are one, so leaving the screen puts back
 * whatever the screen underneath wanted.
 */
const hiders: object[] = [];

function applyVisibility(): void {
  if (!isNativeHost()) {
    return;
  }
  void call("nav.setHeaderVisible", { visible: hiders.length === 0 }).catch(
    () => {
      // A shell that predates this method keeps drawing its header. The screen
      // is still usable, it just carries a bar it has no use for.
    },
  );
}

export function useNativeHeaderHidden(enabled: boolean): void {
  useEffect(() => {
    if (!enabled) {
      return;
    }

    const entry = {};
    hiders.push(entry);
    applyVisibility();

    return () => {
      const index = hiders.lastIndexOf(entry);
      if (index !== -1) {
        hiders.splice(index, 1);
      }
      applyVisibility();
    };
  }, [enabled]);
}
